<template>
  <Listbox
    v-slot="{ open }"
    as="div"
    by="slug"
    class="relative w-full"
    :model-value="modelValue"
    @update:model-value="(value) => emit('update:modelValue', value)"
  >
    <!-- HEADER -->
    <ListboxButton
      :id="`headlessui-listbox-button-${title}`"
      v-slot="{ value }"
      class="w-full"
      :class="variantStyle"
    >
      <div class="flex w-full items-center justify-between gap-[0.25em] pb-1">
        <span class="truncate typo-subtitle">
          {{ value.title || placeholder || $t('forms.please_chose') }}
        </span>
        <IconChevron class="ml-1 size-7 shrink-0 rotate-0 transition-all md:size-7 ui-open:rotate-180" />
        <!-- <IconClose
          v-else
          class="size-6 shrink-0 md:size-5"
          @click="emit('update:modelValue', {})"
        /> -->
      </div>
    </ListboxButton>

    <!-- OPTIONS -->
    <Transition :open="open" name="fade">
      <ListboxOptions
class="
        absolute top-full z-20 max-h-80 w-full max-w-full overflow-hidden overflow-y-auto bg-grey-100
      "
      >
        <ListboxOption
          v-for="option in options"
          :key="option.slug"
          :value="option"
          class="
            max-w-full cursor-pointer truncate p-3 pl-4 transition-colors typo-subtitle
            hover:bg-grey-300
            ui-selected:bg-primary-900 ui-selected:text-white
          "
        >
          {{ option.title }}
        </ListboxOption>
      </ListboxOptions>
    </Transition>
  </Listbox>
</template>

<!-- eslint-disable-next-line vue/block-lang -->
<script setup>
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from '@headlessui/vue'

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: '',
  },
  options: {
    type: Array,
    default: () => [],
  },
  modelValue: {
    type: Object,
    default: () => ({}),
  },
  variant: {
    type: String,
    default: '',
  },
  size: {
    type: String,
    default: '',
  },
})

const variantStyle = computed(() => {
  const classes = [``]

  if (props.variant === 'gray') {
    classes.push(`
      border-b bg-grey-100
      transition-colors
      ui-open:border-b-transparent
    `)

    if (props.size === 'sm') {
      classes.push(`
      pl-3 pr-2
    `)
    }

    if (props.size === 'lg') {
      classes.push(`
      pl-4 pr-3
    `)
    }
  }

  if (props.size === 'sm') {
    classes.push(`
      pt-1
    `)
  }

  if (props.size === 'lg') {
    classes.push(`
      pt-4 pb-[0.6875rem]
    `)
  }

  return classes.join(' ')
})

const emit = defineEmits(['update:modelValue'])
</script>
